// removed by extract-text-webpack-plugin
module.exports = {"dropdowneditor":"_4pkiZ3tkTBeBq_AVy0Lq8","dropdownsearch":"_1CHz9i2GBdcuaWgvKJN1AA","dropdownoptionslist":"_1pWLhhpV9utrEx6uxgCZ_j","dropdownoption":"_6abiK9hGEoF7ZS67I8Ake","hightlighted":"Qqvye9zrK725u6khr35s"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/DropDownEditor.css
// module id = 1838
// module chunks = 0